const Backbone = require('backbone');
var HeadingView = Backbone.View.extend({
	initialize: function() {
		this.$subHeading = $('.js-sub-heading');
		this.$productModel = $('.js-product-model');

		this.listenTo(Backbone, 'finish:clicked', this.render);
	},

	el: '#heading',

	render: function(data) {
		var model = data.sku ? data.sku : this.model.get('productId'),
			name = data.name && !data.name.trim().match(/^n\/?a$/i) ? data.name : '',
			subHeading = data.title ? `${name} ${data.title}` : this.model.get('title');
		if (window.BCOM.device.isDesktop && (window.BCOM.theme.isDps || window.BCOM.theme.isNiche)) {
			this.$subHeading.html(`${model} ${subHeading}`);
		} else {
			this.$el.html(`${model}`);
			this.$subHeading.html(subHeading);
		}
		this.$productModel.text(model);
	}
});

module.exports = HeadingView;
